// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2C7iJ","buttons":"RemoveExpirationActionButtons_buttons__13ewh"};